import {
  CheckIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/20/solid";

import type { CellSaveStatus } from "../../../hooks/useCellSaveState";

type CellSaveStatusIndicatorProps = {
  status?: CellSaveStatus;
};

const statusLabels: Partial<Record<CellSaveStatus, string>> = {
  saving: "Saving",
  saved: "Saved",
  error: "Save failed",
};

/** Keeps inline-edit feedback consistent across table input types. */
export default function CellSaveStatusIndicator({
  status = "idle",
}: CellSaveStatusIndicatorProps) {
  const label = statusLabels[status];

  return (
    <span
      className="inline-flex h-4 w-4 shrink-0 items-center justify-center"
      role={label ? "status" : undefined}
      aria-label={label}
      title={label}
    >
      {status === "saving" ? (
        <span
          className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-300 border-t-accent"
          aria-hidden="true"
        />
      ) : status === "saved" ? (
        <CheckIcon className="h-4 w-4 text-green-600" aria-hidden="true" />
      ) : status === "error" ? (
        <ExclamationCircleIcon
          className="h-4 w-4 text-danger"
          aria-hidden="true"
        />
      ) : null}
    </span>
  );
}
